import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    badgeLabel: 'Simplified payment',
    cardTitle: 'Add credit cards as payment method for your invoices',
    modal: {
      cancel: 'Cancel',
      ctaText: 'Add this payment method',
      description:
        'Offer the simplest payment method and save time for both you and your customers.',
      fees: 'Fees applied: {cardPayinEuro} fees for payments inside EU and {cardPayinNonEuro} fees for payments outside EU',
      title: 'Offer your customers the option of paying by credit card',
    },
    toast: {
      error: 'An error occurred while saving your changes',
      success: 'Your changes have been saved',
    },
  },
  fr: {
    badgeLabel: 'Paiement simplifié',
    cardTitle:
      'Ajouter la carte bancaire comme moyen de paiement de vos factures',
    modal: {
      cancel: 'Annuler',
      ctaText: 'Ajouter ce moyen de paiement',
      description:
        'Proposez le moyen de paiement le plus simple et faites gagner du temps à vos client·es comme à vous.',
      fees: "Des frais s'appliquent : Commission de {cardPayinEuro} pour les paiements en UE et commission de {cardPayinNonEuro} pour encaissement hors zone UE",
      title: 'Proposez à vos client·es de payer par carte bancaire',
    },
    toast: {
      error:
        'Une erreur est survenue lors de la sauvegarde de vos modifications',
      success: 'Vos modifications ont été sauvegardées',
    },
  },
} as const);

export default locales;
